<template>
<div>
  <pt-refund-table class="pt-refund-table__withData" :total-number="totalNumber" :table-data="tableData" ref="table" :pageSize="pageSize" @refundList="refundList"
  :isOutside="isOutside" :loading="loading">
  <slot/>
  </pt-refund-table>
  </div>
</template>

<script>
import PtRefundTable from './index'
export default {
  name: 'pt-refund-table__withData',
  components: {
    'pt-refund-table': PtRefundTable
  },
  props: {
    queryParams: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    selectTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: [],
      loading: false,
      // 是否外部默认调用一次列表函数
      isOutside: false
    }
  },
  watch: {
    queryParams: {
      handler: function (val) {
        if (!this.isFromRouter) {
        //   this.refundList(0)
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.refundList(this.page)
        }
      }
    },
    selectTab: {
      handler: function (val) {
        // this.refundList(0)
        this.$refs.table.resetPage()
      }
    }
  },
  methods: {
    refundList (page, next, size) {
      let queryParams = JSON.parse(JSON.stringify(this.queryParams))
      let data = {
        ...queryParams,
        pageable: {
          page: page,
          size: size || this.pageSize
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('refundmentOrders', data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$refs.table.showReTry()
        this.$message.error(err || '查询订单列表失败')
      })
    }
  }
}
</script>
